export const featuredArticle = {
  path: "/article/alerte-securite-faux-virus-windows",
  title: "Alerte sécurité : faux virus Windows",
  shortSummary:
    "Des popups imitent une infection Windows pour vous faire appeler un faux support : ne cliquez pas, fermez la page et nettoyez votre navigateur.",
};
